function urlencodeFormData(fd) {
    let s = '';
    function encode(s) {
        return encodeURIComponent(s).replace(/%20/g, '+');
    }
    fd.forEach((value, key, _parent) => {
        if (typeof value == 'string') {
            s += (s ? '&' : '') + encode(key) + '=' + encode(value);
        }
    });
    return s;
}

export default () => ({
    init() {
        this.$el.addEventListener('submit', (e) => {
            e.preventDefault();
            fetch('/change-locale', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: urlencodeFormData(new FormData(this.$el)),
            })
                .then(async (r) => {
                    const contentType = r.headers.get('content-type') || '';
                    if (!r.ok || !contentType.includes('application/json')) {
                        return null;
                    }
                    return r.json();
                })
                .then((r) => {
                    if (!r || !r.region) {
                        window.location.href = '/';
                        localStorage.setItem('lang_pref', '');
                        return;
                    }
                    localStorage.setItem('lang_pref', JSON.stringify(r.region));
                    window.location.href = `/${r.region}/`;
                });
        })
    },
});
